import { useContext, useMemo } from "react";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";

import ProductCarousel from "@components/store/product-detail/shared/product-detail-carousel";
import ByoDetails from "@components/store/product-detail/byo/byo-details";

import { useProductInfoContext } from "@contexts/product-info-context";

import styles from "./main.module.scss";

const ByoCategory = ({ product, masterVariant }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const { renderCatalogModeFooterLinks, modalClasses } = useProductInfoContext();

  const { productImgClass = "", productContentClass = "" } = modalClasses;

  const sliderImages = useMemo(
    () =>
      product.variantImages
        ? product.variantImages?.map((image, index) => {
            return { id: `image${index}`, image };
          })
        : [{ id: `image${product.id}`, image: product.baseImage }],
    [product],
  );

  const renderByoProduct = () => (
    <div className={styles.byoListingPage}>
      <div className={styles.title}>Build-Your-Own Box</div>
      <div className={`${styles.rowProductDetail} byoCategory`}>
        <div className={`${styles.productCarousalWrapper} ${productImgClass}`}>
          <ProductCarousel sliderImages={sliderImages} imageMagnify />
        </div>
        <article
          className={`${styles.productDetail} ${styles.byoProductDetail} ${productContentClass}`}
        >
          <div className={styles.productDetailBox}>
            <ByoDetails product={product} masterVariant={masterVariant} />
          </div>
          {renderCatalogModeFooterLinks()}
        </article>
      </div>
    </div>
  );
  return isMobileDevice ? (
    <BottomIconHideWrapper>{renderByoProduct()}</BottomIconHideWrapper>
  ) : (
    renderByoProduct()
  );
};

export default ByoCategory;
